import { downloadPdf } from '../../common/utils/pdfUtils';
import { fetcher } from '../../http/Fetcher';

export async function downloadCombinedStatement(
    userId: string,
    yearMonth: string,
): Promise<string> {
    const response: { data: string } = await fetcher({
        method: 'POST',
        endpoint: `/api/bank-accounts/user/${userId}/statement`,
        body: JSON.stringify({ yearMonth }),
    });

    const filename = `Fruitful_statement_${yearMonth.substring(0, 7)}.pdf`; // yyyy-mm
    return await downloadPdf(response, filename);
}

export async function downloadTaxDocument(
    userId: string,
    year: string,
): Promise<string> {
    const response: { data: string } = await fetcher({
        method: 'POST',
        endpoint: `/api/bank-accounts/user/${userId}/tax-document`,
        body: JSON.stringify({ year }),
    });

    const filename = `Fruitful_1099_INT_${year}.pdf`;
    return await downloadPdf(response, filename);
}
